<template>
  <!--
          作者：kmdshop
          时间：2019-10-25
          描述：会员-用户列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline">
        <el-form-item label="" style="display: inline-block;width: 100%;">
          <el-tabs v-model="formInline.role_type" @tab-click="handleVipTabClick" style="display: inline-block;width: 100%;" >
            <el-tab-pane label="全部" name="0"></el-tab-pane>
            <el-tab-pane label="企业" name="1"></el-tab-pane>
            <el-tab-pane label="商会" name="2"></el-tab-pane>
            <el-tab-pane label="个人VIP" name="3"></el-tab-pane>
            <el-tab-pane label="经销商" name="4"></el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="用户">
          <el-input v-model="formInline.search" placeholder="用户ID或者手机号或者昵称"></el-input>
        </el-form-item>
        <el-form-item label="推荐人">
          <el-input v-model="formInline.agent_id" placeholder="用户ID"></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="formInline.role" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in role" :key="index" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="会员等级">
          <el-select v-model="formInline.grade_id" placeholder="请选择">
            <el-option label="全部" value="0"></el-option>
            <el-option v-for="(item, index) in gradeList" :key="index" :label="item.name" :value="item.grade_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="注册时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.reg_date" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item> <el-button size="small" type="primary" icon="el-icon-plus" @click="addClick1"
      v-auth="'/user/user/add'">添加会员</el-button></el-form-item>
      </el-form>
      <div class="operaction" style="display: flex;">
        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="ChangeGrade">批量修改等级</el-button>
        </div>
        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="batchForbidden">批量封禁</el-button>
        </div>
        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="batchRelieve">批量解封</el-button>
        </div>

        <div class="common-level-rail" style="margin-right:20px;">
          <el-button size="small" @click="batchExport">批量导出</el-button>
        </div>
      </div>
    </div>

    <div>

    </div>

    <!--内容-->
    <div class="product-content" style="margin-top: -40px;">
      <div class="table-wrap">
        <!-- <div >
        <el-tabs v-model="activeRole" @tab-click="handleRoleChange">
          <el-tab-pane label="全部用户" name="all"></el-tab-pane>
          <el-tab-pane label="省代" name="province_agent"></el-tab-pane>
          <el-tab-pane label="市代" name="city_agent"></el-tab-pane>
        </el-tabs>
      </div> -->
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="45"></el-table-column>
          <el-table-column prop="user_id" label="ID" width="80"></el-table-column>

          <!-- 用户角色标签 -->
          <el-table-column prop="role" label="角色" width="100">
            <template slot-scope="scope">
              <el-tag
                :type="getRoleTagType(scope.row.role)"
                size="small"
                effect="light"
              >
                {{ getRoleText(scope.row.role) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="nickName" label="昵称" width="120">
            <template slot-scope="scope">
              <p>{{ scope.row.nickName }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="120">
            <template slot-scope="scope">
              <p>{{ scope.row.mobile }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="is_forbidden" label="状态" width="80">
            <template slot-scope="scope">
              <div v-if="scope.row.is_forbidden==0">
                <p>启用</p>
              </div>
              <div v-if="scope.row.is_forbidden==1">
                <p>禁用</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="avatarUrl" label="微信头像">
            <template slot-scope="scope">
              <div v-if="scope.row.avatarUrl">
                <img :src="scope.row.avatarUrl" width="30px" height="30px"/>
              </div>
            </template>
          </el-table-column>
           <el-table-column prop="jxs.nickName" label="所属经销商"></el-table-column>
          <el-table-column prop="" label="会员等级">
            <template slot-scope="scope">
              <span v-if="scope.row.grade_id == 0">无等级</span>
              <span v-else>{{ scope.row.grade ? scope.row.grade.name : '' }}</span>
            </template>
          </el-table-column>
           <el-table-column prop="expire_date_text" label="年限"></el-table-column>
          <!-- <el-table-column prop="points" label="积分"></el-table-column> -->
          <el-table-column prop="balance" label="余额"></el-table-column>
          <el-table-column prop="money" label="可提现佣金"></el-table-column>

          <!-- 代理类型 -->
          <!-- <el-table-column prop="agent_type" label="代理类型" width="80">
            <template slot-scope="scope">
              <el-tag
                v-if="scope.row.agent_type === 1"
                type="success"
                size="small"
              >
                省代
              </el-tag>
              <el-tag
                v-else-if="scope.row.agent_type === 2"
                type="warning"
                size="small"
              >
                市代
              </el-tag>
              <span v-else>--</span>
            </template>
          </el-table-column> -->

          <el-table-column prop="" label="推荐人" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.referee_id == 0">无</span>
              <span v-else @click="viewUser(scope.row.referee_id)">{{ scope.row.referee_id>0 && scope.row.agent ? scope.row.agent.nickName : '' }}（ID: {{scope.row.referee_id}}）</span>
            </template>
          </el-table-column>
          <el-table-column prop="" label="下级">
            <template slot-scope="scope">
              <span @click="viewFirstUser(scope.row.user_id)">{{scope.row.first_num}} 人</span>
            </template>
          </el-table-column>

          <el-table-column prop="create_time" label="注册时间" width="140"></el-table-column>
          <el-table-column fixed="right" label="操作" width="200">
            <template slot-scope="scope">
              <el-button @click="addClick(scope.row)" type="text" size="small" v-auth="'/user/user/recharge'">充值</el-button>
              <el-button @click="editAdd(scope.row)" type="text" size="small" v-auth="'/user/user/editAdd'">编辑</el-button>
              <a :href="'/h5/#/pages/login/weblogin?app_id=' + app_id + '&user_id='
              +scope.row.user_id+'&change_secret='+scope.row.change_secret" target="_blank"
              v-auth="'/user/user/changeUser'"
              >切换</a>
              <el-button @click="relation(scope.row)" type="text" size="small" v-auth="'/user/user/relation'">关系</el-button>

              <!-- 市级经销商按钮 - 仅对province角色显示 -->
              <el-button 
                v-if="scope.row.role === 'province'" 
                @click="showCityUsers(scope.row)" 
                type="text" 
                size="small" 
                style="color: #67C23A;"
              >
                市级经销商
              </el-button>

              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/user/user/delete'">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        background :current-page="curPage"
        :page-sizes="[20, 100,500, 1000]"
        layout="total,sizes, prev, pager, next, jumper"
        :total="totalDataNumber"></el-pagination>
      </div>
    </div>

    <!--会员充值-->
    <Recharge v-if="open_add" :open_add="open_add" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'add')"></Recharge>

    <!--会员等级-->
    <Grade v-if="open_edit" :open_edit="open_edit" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'edit')"></Grade>

    <Edit v-if="open_kmd" :open_add="open_kmd" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'kmd')"></Edit>

    <Relation v-if="open_relation" :open_add="open_relation" :form="userModel" :gradeList="gradeList" @closeDialog="closeDialogFunc($event, 'relation')"></Relation>

    <!-- 添加客户 -->
    <Add :open="open_add1" :gradeList="gradeList" @close="closeAdd"></Add>
    <!-- 批量修改等级 -->
    <Changegrade :open="open_changegrade" :gradeList="gradeList" :user_ids="select_list" @close="closeChangeggrade"></Changegrade>

    <!-- 市级经销商弹窗 -->
    <el-dialog
      title="市级经销商列表"
      :visible.sync="cityUsersDialogVisible"
      width="80%"
      :before-close="handleCityUsersDialogClose"
    >
      <div class="city-users-dialog">
        <el-table
          :data="cityUsersData"
          border
          style="width: 100%"
          v-loading="cityUsersLoading"
        >
          <el-table-column prop="user_id" label="ID" width="80"></el-table-column>
          <el-table-column prop="nickName" label="昵称" width="120"></el-table-column>
          <el-table-column prop="mobile" label="手机号码" width="120"></el-table-column>
          <el-table-column prop="role" label="角色" width="100">
            <template slot-scope="scope">
              <el-tag
                :type="getRoleTagType(scope.row.role)"
                size="small"
                effect="light"
              >
                {{ getRoleText(scope.row.role) }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="create_time" label="注册时间" width="140"></el-table-column>
          <el-table-column prop="is_forbidden" label="状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.is_forbidden == 0">启用</span>
              <span v-else style="color: #F56C6C;">禁用</span>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 分页 -->
        <div class="pagination" style="margin-top: 20px;">
          <el-pagination
            @size-change="handleCityUsersSizeChange"
            @current-change="handleCityUsersCurrentChange"
            :current-page="cityUsersCurPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="cityUsersPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="cityUsersTotal"
          ></el-pagination>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="cityUsersDialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import UserApi from '@/api/user.js';
import Grade from './dialog/Grade.vue';
import Recharge from './dialog/Recharge.vue';
import Edit from './dialog/Edit.vue';
import Add from './dialog/Add.vue';
import Changegrade from './dialog/Changegrade.vue';
import Relation from './dialog/Relation.vue';
import store from '@/store/'
import qs from 'qs';
export default {
  components: {
    /*编辑组件*/
    Grade,
    Recharge,
    Edit,
    Add,
    Changegrade,
    Relation
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        search: '',
        grade_id: '',
        reg_date: '',
        agent_id: '',
        role: '0', // 默认全部
        role_type:'0',
      },
      /*当前激活的Tab*/
      activeRole: 'all',
      /*是否打开添加弹窗*/
      open_add: false,
      open_add1: false,
      /*是否打开批量修改等级弹窗*/
      open_changegrade: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      open_kmd: false,
      open_relation: false,
      /*当前编辑的对象*/
      userModel: {
        // 会员到期时间设置
        expire_date_text: '',
      },
      /*等级*/
      gradeList: [],
      /*选中的*/
      multipleSelection: [],
      /*选择的会员列表*/
      select_list: [],
      app_id: 10001,
      role:[],
      
      // 市级经销商相关数据
      cityUsersDialogVisible: false,
      cityUsersData: [],
      cityUsersLoading: false,
      cityUsersCurPage: 1,
      cityUsersPageSize: 20,
      cityUsersTotal: 0,
      currentProvinceUser: null, // 当前选中的省级用户
    };
  },
  created() {
    this.getRole()
    this.getBaseInfo()
    /*获取列表*/
    this.getTableList()
  },

  methods: {
    handleVipTabClick() {
      this.curPage = 1;
      this.getTableList();
    },
    // 获取基础信息,获取app_id,跳转路由需要
    async getBaseInfo() {
      let res = await store.dispatch('common/getBaseInfo')
      this.app_id = res.app_id
    },

    /*选择第几页*/
    handleCurrentChange(val) {
      this.curPage = val
      this.getTableList()
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },

    getRole(){
      let self = this
      let Params = {}
      UserApi.getRole(Params, true)
        .then(data => {
          self.role = data.data
        })
        .catch(error => {})
    },

    /*获取列表*/
    getTableList() {
      let self = this
      self.loading = true
      let Params = self.formInline
      Params.page = self.curPage
      Params.list_rows = self.pageSize

      // 根据tab添加角色筛选条件
      if (this.activeRole !== 'all') {
        if (this.activeRole === 'province_agent') {
          Params.agent_type = 1 // 省代
        } else if (this.activeRole === 'city_agent') {
          Params.agent_type = 2 // 市代
        } else {
          Params.role = this.activeRole // 其他角色类型
        }
      }

      UserApi.userlist(Params, true)
        .then(data => {
          self.loading = false
          self.tableData = data.data.list.data
          self.totalDataNumber = data.data.list.total
          self.gradeList = data.data.grade
        })
        .catch(error => {
          self.loading = false
        })
    },

    /*Tab切换事件*/
    handleRoleChange(tab) {
      this.curPage = 1
      // 重置角色筛选条件
      if (this.activeRole === 'all') {
        this.formInline.role = '0'
        delete this.formInline.agent_type
      }
      this.getTableList()
    },

    /*获取角色文本*/
    getRoleText(role) {
      const roleMap = {
        'user': '普通用户',
        'government': '政府用户',
        'shanghui': '商会用户',
        'cross_border': '跨境云',
        'enterprise': '企业',
        'company': '企业用户',
        'province': '省经销商',
        'city': '市经销商',
        'promoter': '业务员'
      }
      return roleMap[role] || role || '未知角色'
    },

    /*获取角色标签类型*/
    getRoleTagType(role) {
      const typeMap = {
        'user': '',
        'government': 'success',
        'shanghui': 'warning',
        'cross_border': 'info',
        'company': 'primary',
        'province': 'success',
        'city': 'warning'
      }
      return typeMap[role] || 'info'
    },

    viewUser(user_id){
      this.curPage = 1;
      this.pageSize = 20;
      this.tableData = [];
      this.formInline.search = user_id;
      this.formInline.agent_id = '';
      this.getTableList();
    },

    viewFirstUser(user_id){
      this.curPage = 1;
      this.pageSize = 20;
      this.tableData = [];
      this.formInline.search = '';
      this.formInline.agent_id = user_id;
      this.getTableList();
    },

    /*搜索查询*/
    onSubmit() {
      let self = this
      self.curPage = 1
      self.getTableList()
    },

    /*打开添加*/
    addClick(item) {
      this.userModel = item;
      this.open_add = true;
    },

    /*打开添加客户*/
    addClick1() {
      this.open_add1 = true;
    },

    /*打开批量修改等级*/
    ChangeGrade() {
      let user_ids = [];
      let params = this.multipleSelection;
      params.forEach((param) => {
        user_ids.push(param.user_id);
      })
      user_ids = user_ids.join(',');
      console.log(user_ids);
      if (user_ids == '') {
        this.$message({
          message: '请选择修改等级的会员',
          type: 'error'
        });
      } else {
        this.open_changegrade = true;
        this.select_list = user_ids;
      }
    },

    /*关闭添加*/
    closeAdd(e) {
      this.open_add1 = false;
      if (e.type == 'success') {
        this.getTableList();
      }
    },

    /*关闭批量修改等级*/
    closeChangeggrade(e) {
      this.open_changegrade = false;
      if (e.type == 'success') {
        this.getTableList();
      }
    },

    /* 编辑会员信息 */
    editAdd(item) {
      this.userModel = item;
      this.open_kmd = true;
    },

    /*打开编辑*/
    editClick(item) {
      this.userModel = item;
      this.open_edit = true;
    },

    /*选择会员*/
    handleSelectionChange(e) {
      this.multipleSelection = e;
    },

    /* 修改会员关系 */
    relation(item) {
      if (!item.user) {
        item.user = {
          grade: {} // 初始化grade对象，避免grade为undefined
        };
      }
      // 初始化grade对象（兜底）
      if (!item.user.grade) {
        item.user.grade = {};
      }
      //获取推荐人用户名昵称
      let self = this
      let Params = {}
      Params.referee_id = item.referee_id;
      UserApi.getRefereeInfo(Params, true)
        .then(data => {
          if(data.code == 1){
            item.user.grade.name = data.data.name;
            item.user.nickName = data.data.nickName
          }else{
            item.user.grade.name = '';
            item.user.nickName = ''
          }
          this.userModel = item;
          this.open_relation = true;
        })
        .catch(error => {
          item.user.grade.name = '';
          item.user.nickName = ''
          this.userModel = item;
          this.open_relation = true;
        })
    },

    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'kmd') {
        this.open_kmd = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'relation') {
        this.open_relation = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },

    /*删除用户*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          self.loading = true
          UserApi.deleteuser(
            {
              user_id: row.user_id
            },
            true
          )
            .then(data => {
              self.loading = false
              if (data.code == 1) {
                self.$message({
                  message: '会员删除成功',
                  type: 'success'
                });
                self.getTableList()
              } else {
                self.loading = false
              }
            })
            .catch(error => {
              self.loading = false
            });
        })
        .catch(() => {
          self.loading = false;
        });
    },

    /*批量禁用用戶*/
    batchForbidden() {
      let user_ids = [];
      let params = this.multipleSelection;
      params.forEach((param) => {
        user_ids.push(param.user_id);
      })
      user_ids = user_ids.join(',');
      console.log(user_ids);
      if (user_ids == '') {
        this.$message({
          message: '请选择要禁用的用户',
          type: 'error'
        });
      } else {
        UserApi.UserForbidden({
          user_ids: user_ids
        }).then(data => {
          this.$message({
            message: '批量禁用用户成功',
            type: 'success'
          });
          this.getTableList();
        });
      }
    },

    /*批量解封用戶*/
    batchRelieve() {
      let user_ids = [];
      let params = this.multipleSelection;
      params.forEach((param) => {
        user_ids.push(param.user_id);
      })
      user_ids = user_ids.join(',');
      console.log(user_ids);
      if (user_ids == '') {
        this.$message({
          message: '请选择要禁解封的用户',
          type: 'error'
        });
      } else {
        UserApi.batchRelieve({
          user_ids: user_ids
        }).then(data => {
          this.$message({
            message: '批量解封用户成功',
            type: 'success'
          });
          this.getTableList();
        });
      }
    },

    batchExportAll(){//导出全部
      var parmasa =  this.searchForm?this.searchForm:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/product.product/exportUser?' +
      qs.stringify(parmasa)+'&user_ids='+""+"&atype=all";
    },

    batchExport(){//批量导出
        // 勾选需要导出的数据
        let user_ids = [];
      let params = this.multipleSelection;
      console.log("params",params)
      params.forEach((param)=>{
        user_ids.push(param.user_id);
      })
      user_ids = user_ids.join(',');
      // 筛选条件
      // 商品状态
      var parmasa =  this.searchForm?this.searchForm:{};
      console.log("parmasa",parmasa)
      parmasa["list_rows"] = this.pageSize
      parmasa["page"] = this.curPage
      console.log("user_ids",user_ids)
      if(user_ids.length > 0){
        // console.log(this.searchForm)
        let baseUrl = window.location.protocol + '//' + window.location.host;
        window.location.href = baseUrl + '/index.php/shop/product.product/exportUser?' +
        qs.stringify(parmasa)+'&user_ids='+user_ids+"&atype=cond";
      }else{
        this.$message({
            message: '请选择要导出的数据',
            type: 'error'
          });
      }
    },

    // 显示市级经销商弹窗
    showCityUsers(row) {
      this.currentProvinceUser = row;
      this.cityUsersDialogVisible = true;
      this.cityUsersCurPage = 1;
      this.getCityUsersList();
    },

    // 获取市级经销商列表
    getCityUsersList() {
      if (!this.currentProvinceUser) return;
      
      this.cityUsersLoading = true;
      const params = {
        page: this.cityUsersCurPage,
        list_rows: this.cityUsersPageSize,
        role: 'city', // 筛选市级经销商
        agent_id: this.currentProvinceUser.user_id // 根据省级经销商的ID筛选
      };

      UserApi.userlist(params, true)
        .then(data => {
          this.cityUsersLoading = false;
          this.cityUsersData = data.data.list.data || [];
          this.cityUsersTotal = data.data.list.total || 0;
        })
        .catch(error => {
          this.cityUsersLoading = false;
          this.$message.error('获取市级经销商列表失败');
        });
    },

    // 市级经销商分页大小改变
    handleCityUsersSizeChange(val) {
      this.cityUsersPageSize = val;
      this.cityUsersCurPage = 1;
      this.getCityUsersList();
    },

    // 市级经销商当前页改变
    handleCityUsersCurrentChange(val) {
      this.cityUsersCurPage = val;
      this.getCityUsersList();
    },

    // 关闭市级经销商弹窗
    handleCityUsersDialogClose() {
      this.cityUsersDialogVisible = false;
      this.currentProvinceUser = null;
      this.cityUsersData = [];
      this.cityUsersTotal = 0;
    },
  }
};
</script>

<style scoped>
.role-tabs {
  margin-bottom: 20px;
  background: #fff;
  padding: 10px 20px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.role-tabs >>> .el-tabs__header {
  margin-bottom: 0;
}

.role-tabs >>> .el-tabs__nav-wrap::after {
  height: 1px;
}

.role-tabs >>> .el-tabs__item {
  font-size: 14px;
  padding: 0 20px;
}

.common-seach-wrap {
  background: #fff;
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.operaction {
  background: #fff;
  padding: 15px 20px;
  border-radius: 4px;
  margin-bottom: 20px;
}

.city-users-dialog {
  max-height: 60vh;
  overflow-y: auto;
}
</style>


// WEBPACK FOOTER //
// src/views/user/user/index.vue